import { API_TOKEN } from '@/environment'
import { type AttensiFetchError, createAttensiFetch } from '../attensiFetch'
import { getAccessToken } from '../activeSession'

export const customFetch = createAttensiFetch({
  getHeaders,
  onError,
})

export async function getHeaders() {
  return {
    Accept: 'application/vnd.api+json',
    Authorization: 'Bearer ' + (await getAccessToken()),
    'API-Token': API_TOKEN,
    'Content-Type': 'application/vnd.api+json',
  }
}

function onError(e: AttensiFetchError) {
  console.error(e.cause)
}
